var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvStationOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "pantographe",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_326",
    "data-name": "Rectangle 326",
    width: 16.5,
    height: 18,
    fill: "#333"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#333",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1888",
    "data-name": "Groupe 1888",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1887",
    "data-name": "Groupe 1887",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_609",
    "data-name": "Trac\\xE9 609",
    d: "M15.77,4.23l.01-.01L12.06.5,11,1.56l2.11,2.11A2.5,2.5,0,0,0,14,8.5a2.556,2.556,0,0,0,1-.21V15.5a1,1,0,0,1-2,0V11a2.006,2.006,0,0,0-2-2H10V2A2.006,2.006,0,0,0,8,0H2A2.006,2.006,0,0,0,0,2V18H10V10.5h1.5v5a2.5,2.5,0,0,0,5,0V6a2.5,2.5,0,0,0-.73-1.77M8,8v8H2V2H8Zm6-1a1,1,0,1,1,1-1,1,1,0,0,1-1,1M6,3,2,10.5H4V15L8,8H6Z",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvStationOutlined);
export default __webpack_public_path__ + "static/media/EvStationOutlined.2eb38400136003b5b5dd13b146cc88f4.svg";
export { ForwardRef as ReactComponent };